import Quiz from ".";
import ServiceCategory from ".";
import ManageQuiz from "../../../../components/sections/admin/Quiz/ManageQuiz";

export const quizRoutes = () => [
  {
    path: "/admin/quiz",
    title: "Quiz Management",
    layout: "admin",
    routeType: "admin",
    component: Quiz,
  },
  {
    path: "/admin/manage-quiz",
    component: ManageQuiz,
    layout: "admin",
    routeType: "admin",
    title: "Manage Quizes",
  },
  {
    path: `/admin/manage-quiz/:id`,
    component: ManageQuiz,
    layout: "admin",
    routeType: "admin",
    title: "Manage Quizes",
  },
];
